import programStore from './program/programStore';

export const program = programStore;